// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import lock01Icon from "@/assets/icons/lock-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Lock01IconProps = Omit<IconProps, "name">;

export function Lock01Icon(props: Lock01IconProps): React.ReactNode {
  return <Icon name={lock01Icon} {...props} />;
}
